"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomestikaFeaturedLiveCardDefaultProps = exports.DomestikaFeaturedLiveCardPropTypes = exports.DomestikaFeaturedLiveCard = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _styledSystem = require("styled-system");

var _Card = require("../../atoms/Card");

var _DomestikaLiveCardImage = require("../../atoms/DomestikaLiveCardImage");

var _DomestikaLiveCardInfo = require("../../atoms/DomestikaLiveCardInfo");

var _DomestikaLiveCardSkeleton = require("../../atoms/DomestikaLiveCardSkeleton");

var _DomestikaLiveTag = require("../../atoms/DomestikaLiveTag");

var _Icon = require("../../atoms/Icon");

var _Icons = require("../../atoms/Icons");

var _Layout = require("../../atoms/Layout");

var _Typography = require("../../atoms/Typography");

var _When = _interopRequireDefault(require("../../utils/When"));

var _withTooltip = require("../../HOC/withTooltip");

var _hooks = require("../../utils/hooks");

var _validate = require("./validate");

var StyledCard = (0, _styledComponents.default)(_Card.Card).withConfig({
  displayName: "DomestikaFeaturedLiveCard__StyledCard",
  componentId: "sc-9q97a6-0"
})({
  padding: '0',
  overflow: 'hidden',
  cursor: 'pointer'
}, (0, _styledSystem.variant)({
  prop: 'loading',
  variants: {
    true: {
      cursor: 'default'
    }
  }
}));
var StyledOverlay = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "DomestikaFeaturedLiveCard__StyledOverlay",
  componentId: "sc-9q97a6-1"
})({
  width: '100%'
}, (0, _styledSystem.variant)({
  prop: 'overlayPosition',
  variants: {
    bottom: {
      height: ['0', '98px', '126px', '160px'],
      background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0) 100%)',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end'
    },
    top: {
      height: ['224px', '194px', '252px', '320px'],
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0) 100%)'
    }
  }
}));
var StyledHover = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "DomestikaFeaturedLiveCard__StyledHover",
  componentId: "sc-9q97a6-2"
})({
  zIndex: 20,
  width: '100%',
  height: '100%',
  transition: 'background-color .2s linear',
  backgroundColor: 'transparent',
  flexDirection: 'column',
  justifyContent: 'space-between',
  float: 'left'
}, (0, _css.default)({
  ':hover': {
    backgroundColor: 'ghosted.sonar.dark'
  }
}));
var StyledUpperElementsWrapper = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "DomestikaFeaturedLiveCard__StyledUpperElementsWrapper",
  componentId: "sc-9q97a6-3"
})((0, _css.default)({
  justifyContent: ['flex-start', 'flex-end'],
  paddingLeft: [4, 0],
  paddingRight: [0, 4, 5],
  paddingTop: [4, 4, 5],
  zIndex: 20
}));
var StyledIconWrapper = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "DomestikaFeaturedLiveCard__StyledIconWrapper",
  componentId: "sc-9q97a6-4"
})({
  cursor: 'default',
  padding: '6px'
}, (0, _styledSystem.variant)({
  prop: 'rounded',
  variants: {
    true: {
      borderRadius: '50%'
    }
  }
}));
var StyledIcon = (0, _styledComponents.default)(_Icon.IconForm).withConfig({
  displayName: "DomestikaFeaturedLiveCard__StyledIcon",
  componentId: "sc-9q97a6-5"
})({
  fontSize: '20px',
  lineHeight: '20px'
});

var LockIcon = function LockIcon(props) {
  return _react.default.createElement(StyledIconWrapper, (0, _extends2.default)({
    backgroundColor: "coco",
    rounded: true
  }, props), _react.default.createElement(StyledIcon, null, _react.default.createElement(_Icons.Lock, null)));
};

var StudentIcon = function StudentIcon(props) {
  return _react.default.createElement(StyledIconWrapper, (0, _extends2.default)({
    backgroundColor: "quandog",
    rounded: true
  }, props), _react.default.createElement(StyledIcon, {
    color: "coco"
  }, _react.default.createElement(_Icons.Cap, null)));
};

var Timer = function Timer(_ref) {
  var startedAt = _ref.startedAt;

  var _useTimer = (0, _hooks.useTimer)({
    initialTime: startedAt
  }),
      time = _useTimer.time;

  return _react.default.createElement(_Layout.Flex, {
    justifyContent: "space-between",
    alignItems: "center"
  }, _react.default.createElement(_Icon.IconForm, {
    color: "coco"
  }, _react.default.createElement(_Icons.Clock, null)), _react.default.createElement(_Typography.Text, {
    size: "micro",
    fontWeight: "medium",
    color: "coco",
    textAlign: "left",
    marginLeft: 1,
    style: {
      minWidth: '60px'
    }
  }, time));
};

var Viewers = function Viewers(_ref2) {
  var viewers = _ref2.viewers;
  return _react.default.createElement(_Layout.Flex, {
    justifyContent: "space-between",
    alignItems: "center"
  }, _react.default.createElement(_Icon.IconForm, {
    color: "coco"
  }, _react.default.createElement(_Icons.UsersNew, null)), _react.default.createElement(_Typography.Text, {
    size: "micro",
    fontWeight: "medium",
    color: "coco",
    marginLeft: 1
  }, viewers));
};

var DomestikaFeaturedLiveCard = function DomestikaFeaturedLiveCard(_ref3) {
  var streamers = _ref3.streamers,
      liveInfo = _ref3.liveInfo,
      liveLabel = _ref3.liveLabel,
      loading = _ref3.loading,
      locked = _ref3.locked,
      lockedTooltip = _ref3.lockedTooltip,
      student = _ref3.student,
      studentTooltip = _ref3.studentTooltip,
      onClick = _ref3.onClick,
      observerRootElement = _ref3.observerRootElement,
      lazyLoading = _ref3.lazyLoading,
      width = _ref3.width,
      height = _ref3.height;

  if (!loading) {
    (0, _validate.validate)({
      streamers: streamers,
      liveInfo: liveInfo,
      onClick: onClick
    });
  }

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      upperElements = _useState2[0],
      setUpperElements = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      upperElementsWrapperMargin = _useState4[0],
      setUpperElementsWrapperMargin = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      bottomIcon = _useState6[0],
      setBottomIcon = _useState6[1];

  var _useLazyLoadElement = (0, _hooks.useLazyLoadElement)({
    lazyLoading: lazyLoading,
    rootElement: observerRootElement,
    rootMargin: '0px'
  }),
      isElementVisible = _useLazyLoadElement.isElementVisible,
      getElementRef = _useLazyLoadElement.getElementRef;

  var getUpperElementsWrapperRef = function getUpperElementsWrapperRef(node) {
    if (node !== null) {
      var nodeHeight = node.getBoundingClientRect().height;
      setUpperElementsWrapperMargin(nodeHeight * -1);
    }
  };

  var getElementMargin = function getElementMargin(index) {
    var iconsListLastElement = upperElements.length - 1;
    return index < iconsListLastElement ? [3, 4] : 0;
  };

  var isLoadingState = function isLoadingState() {
    return loading || !isElementVisible;
  };

  (0, _react.useEffect)(function () {
    var elements = [function () {
      return _react.default.createElement(_DomestikaLiveTag.DomestikaLiveTag, null);
    }];

    if ((liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.startedAt) !== undefined && (liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.startedAt) !== null) {
      elements.push(function () {
        return _react.default.createElement(Timer, {
          startedAt: liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.startedAt
        });
      });
    }

    if ((liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.viewers) !== undefined && (liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.viewers) !== null) {
      elements.push(function () {
        return _react.default.createElement(Viewers, {
          viewers: liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.viewers
        });
      });
    }

    setUpperElements(elements);
  }, [liveInfo]);
  (0, _react.useEffect)(function () {
    if (locked) {
      setBottomIcon(function () {
        return (0, _withTooltip.WithTooltip)(LockIcon, {
          position: 'left',
          message: lockedTooltip,
          id: 'dmstk-featured-live-lock-icon-tooltip'
        });
      });
    } else if (student) {
      setBottomIcon(function () {
        return (0, _withTooltip.WithTooltip)(StudentIcon, {
          position: 'left',
          message: studentTooltip,
          id: 'dmstk-featured-live-student-icon-tooltip'
        });
      });
    } else {
      setBottomIcon(null);
    }
  }, [locked, student]);
  return _react.default.createElement("div", {
    ref: getElementRef
  }, _react.default.createElement(StyledCard, {
    onClick: onClick,
    borderRadius: 4,
    width: width,
    height: height,
    loading: isLoadingState() ? 'true' : 'false'
  }, _react.default.createElement(_When.default, {
    condition: !!isLoadingState()
  }, function () {
    return _react.default.createElement(_Layout.Flex, {
      paddingX: [4, 5, 6],
      paddingY: [3, 5, 6],
      height: "100%",
      backgroundColor: "durian"
    }, _react.default.createElement(_DomestikaLiveCardSkeleton.DomestikaLiveCardSkeleton, {
      type: "featured",
      color: "langsat"
    }));
  }), _react.default.createElement(_When.default, {
    condition: !isLoadingState()
  }, function () {
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_DomestikaLiveCardImage.DomestikaLiveCardImage, {
      imageUrl: liveInfo === null || liveInfo === void 0 ? void 0 : liveInfo.coverUrl,
      lazyLoading: lazyLoading
    }), _react.default.createElement(StyledHover, null, _react.default.createElement(StyledOverlay, {
      overlayPosition: "top"
    }, _react.default.createElement(StyledUpperElementsWrapper, {
      ref: getUpperElementsWrapperRef
    }, upperElements === null || upperElements === void 0 ? void 0 : upperElements.map(function (element, index) {
      return _react.default.createElement(_Layout.Box, {
        key: "dmskt-feature-live-card-element-".concat(index + 1),
        marginRight: getElementMargin(index)
      }, element());
    })), _react.default.createElement(_Layout.Flex, {
      paddingX: [4, 5, 6],
      paddingTop: [3, 5, 6],
      marginTop: [0, "".concat(upperElementsWrapperMargin, "px")],
      style: {
        zIndex: 10
      }
    }, _react.default.createElement(_DomestikaLiveCardInfo.DomestikaLiveCardInfo, {
      liveInfo: liveInfo,
      streamers: streamers,
      liveLabel: liveLabel,
      type: "featured"
    }))), _react.default.createElement(StyledOverlay, {
      overlayPosition: "bottom"
    }, _react.default.createElement(_When.default, {
      condition: !!bottomIcon
    }, function () {
      return _react.default.createElement(_Layout.Flex, {
        alignItems: "center",
        justifyContent: "flex-end",
        paddingRight: [4, 5, 6],
        paddingBottom: [4, 5, 6],
        style: {
          zIndex: 20
        }
      }, _react.default.createElement(_react.default.Fragment, null, bottomIcon()));
    }))));
  })));
};

exports.DomestikaFeaturedLiveCard = DomestikaFeaturedLiveCard;
var DomestikaFeaturedLiveCardPropTypes = {
  streamers: _propTypes.default.arrayOf(_propTypes.default.shape({
    avatar: _propTypes.default.string,
    name: _propTypes.default.string
  })),
  liveInfo: _propTypes.default.shape({
    startedAt: _propTypes.default.string,
    viewers: _propTypes.default.string,
    language: _propTypes.default.string,
    title: _propTypes.default.string,
    coverUrl: _propTypes.default.string
  }),
  liveLabel: _propTypes.default.string,
  loading: _propTypes.default.bool,
  locked: _propTypes.default.bool,
  lockedTooltip: _propTypes.default.string,
  student: _propTypes.default.bool,
  studentTooltip: _propTypes.default.string,
  onClick: _propTypes.default.func,
  lazyLoading: _propTypes.default.bool,
  observerRootElement: _propTypes.default.node,
  width: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  height: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string])
};
exports.DomestikaFeaturedLiveCardPropTypes = DomestikaFeaturedLiveCardPropTypes;
var DomestikaFeaturedLiveCardDefaultProps = {
  streamers: null,
  liveInfo: null,
  liveLabel: null,
  loading: false,
  locked: false,
  lockedTooltip: '',
  student: false,
  studentTooltip: '',
  onClick: null,
  lazyLoading: false,
  observerRootElement: null,
  width: ['100%', '596px', '770px', '980px'],
  height: ['291px', '336px', '436px', '554px']
};
exports.DomestikaFeaturedLiveCardDefaultProps = DomestikaFeaturedLiveCardDefaultProps;
DomestikaFeaturedLiveCard.defaultProps = DomestikaFeaturedLiveCardDefaultProps;